import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormGroupDirective } from '@angular/forms';
import { BaseFormComponent } from '../../../shared/class/base-form.class';
import { LANGUAGES, ORG_STATUS } from '../../../shared/constansts/app.const';
import { MessageType } from '../../../shared/enums/message-type.enum';
import { TimeZoneOffset } from '../../../shared/enums/time-zone.enum';
import { SelectOption } from '../../../shared/models/select-option.model';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../../shared/class/base-component.class';
import { Organization } from '../../../shared/models/Organization.model';
import { ApiResponse } from '../../../shared/interfaces/api-response.interface';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SubscriptionTier } from '../../../subscription/enums/subscription-tier.enum';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';


@Component({
  selector: 'app-edit-org',
  templateUrl: './edit-org.component.html',
  styleUrl: './edit-org.component.scss'
})
export class EditOrgComponent extends BaseFormComponent implements OnInit {
  @ViewChild('formRef')
  formRef!: FormGroupDirective;
  @Input() groupData: any;
  orgDetails: Organization | undefined;


  get formControl() {
    return this.updateOrganizationForm.controls;
  }

  timeZoneOptions = Object.keys(TimeZoneOffset)
    .filter(key => isNaN(Number(key)))
    .map(key => ({
      label: key,
      value: TimeZoneOffset[key as keyof typeof TimeZoneOffset]
    }));

  languagesOptions = LANGUAGES;
  orgStatusOptions = ORG_STATUS;
  subscriptionDurationOptions = ['3 Months', '6 Months', '1 Year', '2 Years']; 
  subscriptionTiers = ['FREE', 'BASIC', 'PREMIUM', 'ENTERPRISE']
  logo: File | null = null;
  filteredSubscriptions: string[] = this.subscriptionTiers; 
  filteredDurations: string[] = this.subscriptionDurationOptions; 
  today: Date = new Date(); 

  constructor(injector: Injector, protected override route: ActivatedRoute, private confirmationService: ConfirmationService, private messageService: MessageService) {
    super();
  }

  updateOrganizationForm = this.fb.group({
    code: new FormControl<string | undefined>(undefined, [Validators.pattern('^[a-zA-Z0-9-+\\s/\\_]*$')]),
    name: new FormControl('', [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(40),
      Validators.pattern('^[a-zA-Z0-9-+\\s/\\_]*$')
    ]),
    description: new FormControl<string | undefined>(undefined),
    adminEmail: new FormControl<string | undefined>(undefined, [Validators.required, Validators.email]),
    adminPhone: new FormControl<string | undefined>(undefined),
    credits: new FormControl<number>(0),
    orgStatus: new FormControl<string | undefined>(undefined),
    gstInNumber: new FormControl<string | undefined>(undefined),
  
  });


  ngOnInit(): void {
    this.id = this.route.snapshot.params['id'];
    if(this.id){
      this.getOrgDetails(this.id);
    }
  }

  async getOrgDetails(orgId: number) {
    if (orgId) {
      let response: ApiResponse<any> = await this.httpService.httpRequest<any>(
        "organization",
        "get-by-admin",
        {
          id: orgId,
        }
      );
      if (response.status) {
        this.orgDetails = response.data!;
        this.updateOrganizationForm.patchValue({
          ...this.orgDetails as any
        });

        return;
      }
    }
  }

  async updateOrg(){
    if(this.updateOrganizationForm.valid){
           let payload = this.updateOrganizationForm.value;
           payload = {
             ...payload,
             id: this.id
           } as any
           let response: ApiResponse<any> = await this.httpService.httpRequest<any>(
             "organization",
             "update-by-admin",
             payload
           );
        if(response.status && response.data){
       this.notificationService.showSuccess(response.message);
       this.updateOrganizationForm.reset();
       this.router.navigateByUrl("/settings/org");
       return;
        }else{
         this.notificationService.showError(response.message);
        }
    }
  }

  onUpload(event: any) {
    // this.logo = event.files[0];
    // this.updateOrganizationForm.get('logo')?.setValue(this.logo);
  }
}
